import { Component, type ErrorInfo, type ReactNode } from 'react';

type Props = { children: ReactNode; onReset?: () => void };

type State = { error: Error | null };

export class DripErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[drip-dashboard]', error, info.componentStack);
  }

  render() {
    if (this.state.error) {
      return (
        <div
          role="alert"
          className="rounded-2xl border border-rose-400/40 bg-rose-950/35 p-6 text-rose-100"
        >
          <p className="font-display text-sm font-semibold uppercase tracking-wide">Section error</p>
          <p className="mt-2 font-body text-sm">{this.state.error.message}</p>
          <button
            type="button"
            className="mt-4 rounded-lg bg-white/10 px-4 py-2 text-sm font-medium text-white hover:bg-white/20"
            onClick={() => {
              this.setState({ error: null });
              this.props.onReset?.();
            }}
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
